import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import DebtReliefOasisWrapper from "@components/layouts/debtReliefOasisWrapper";
import { useDomainContext } from "@hooks/useDomainContext";

export default function TermsAndConditionsHome(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <DebtReliefOasisWrapper boxShadow="0px -2px 10px #888888">
            <TermsAndConditions
                category={domain?.categories[0]?.name}
                domain={domain.niceName}
            />
        </DebtReliefOasisWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
